module.exports = __webpack_public_path__ + "img/sepa.81c82bfa.svg";